export const PRODUCT_NAME = 'ARD.de';
